import React from "react";
import { Loader as MantineLoader } from "@mantine/core";

const Loader = () => {
  return (
    <div className="w-[100%] h-[100vh] flex justify-center items-center">
      <MantineLoader color="blue" size="lg" />
    </div>
  );
};

export default Loader;
